type GetBaseFetchHeadersArgs = {
  widgetToken?: string;
  withContentType?: boolean;
};

export function getBaseFetchHeaders({
  widgetToken,
  withContentType = false
}: GetBaseFetchHeadersArgs) {
  const headers: HeadersInit = {};

  if (withContentType) {
    headers['Content-Type'] = 'application/json';
  }

  if (widgetToken) {
    headers['x-widget-token'] = widgetToken;
  }

  return headers;
}
